import { ITEM_ICONS } from '@/main/app.constants';
import { ALL_CUSTOMIZATIONS_PROPERTIES, ITEM_DATA_STATUS, ITEM_TYPES } from '@/trendData/trendData.constants';

export const iconClasses = {
  [ITEM_TYPES.SERIES]: ITEM_ICONS.SERIES,
  [ITEM_TYPES.CAPSULE]: ITEM_ICONS.CAPSULE,
  [ITEM_TYPES.ANNOTATION]: ITEM_ICONS.ANNOTATION,
  [ITEM_TYPES.CONDITION]: ITEM_ICONS.CONDITION,
  [ITEM_TYPES.SCALAR]: ITEM_ICONS.SCALAR,
  [ITEM_TYPES.TABLE]: ITEM_ICONS.TABLE,
  [ITEM_TYPES.METRIC]: ITEM_ICONS.METRIC,
  [ITEM_TYPES.SCALING_COLUMN]: ITEM_ICONS.TABLE_DEFINITION,
};

export const translateKeys = {
  [ITEM_TYPES.SERIES]: 'SERIES',
  [ITEM_TYPES.CAPSULE]: 'CAPSULE',
  [ITEM_TYPES.CONDITION]: 'CAPSULE_SERIES',
  [ITEM_TYPES.ANNOTATION]: 'ANNOTATION',
  [ITEM_TYPES.SCALAR]: 'SCALAR',
  [ITEM_TYPES.TABLE]: 'TABLE',
  [ITEM_TYPES.METRIC]: 'METRIC',
  [ITEM_TYPES.SCALING_COLUMN]: 'COLUMN',
};

export const COMMON_PROPS = {
  items: [],
  dataStatus: ITEM_DATA_STATUS.PRESENT,
  warningCount: 0,
  warningLogs: [],
  timingInformation: '',
  meterInformation: '',
};

/**
 * Properties from createItem() that should always be dehydrated.
 */
export const PROPS_TO_DEHYDRATE = ALL_CUSTOMIZATIONS_PROPERTIES.concat([
  'childType',
  'id',
  'name',
  'selected',
  'autoDisabled',
  'color',
  'tableId',
  'rowId',
  'columnId',
  'nodePath',
  'hierarchyId',
  'hierarchyName',
  'alias',
  'isScalingTableCSVFlow',
  'datumId',
  'instanceId',
]);
